(function () {
  let lastInputWasKeyboard = false;

  // Detect Tab for keyboard navigation
  document.addEventListener("keydown", (e) => {
    if (e.key === "Tab") {
      lastInputWasKeyboard = true;
    }
  });

  // Reset on mouse click
  document.addEventListener("mousedown", () => {
    lastInputWasKeyboard = false;
  });

  document.addEventListener("focusin", (event) => {
    if (!lastInputWasKeyboard) return;

    const el = event.target;

    // Ignore dropdowns / typeaheads
    if (
      el.closest(".dropdown") ||
      el.closest(".autocomplete") ||
      el.closest(".country-typeahead") ||
      el.closest(".suggestion-box")
    ) {
      return;
    }

    // ----- DETECT HEADER HEIGHT -----

    let headerHeight = 0;

    // Mobile header
    if (window.matchMedia("(max-width: 768px)").matches) {
      const mobileHeader = document.querySelector("#bgn-header-mobile");
      if (mobileHeader) headerHeight = mobileHeader.offsetHeight;
    }
    // Desktop header
    else {
      // Existing desktop header
      const desktopHeader = document.querySelector(".bgr-header");
      if (desktopHeader) headerHeight = desktopHeader.offsetHeight;

      // ✅ NEW HEADER TYPE from your screenshot
      const newHeader = document.querySelector(
        ".header.header-branding.header-thin.header-thin-new.hide-on-scroll"
      );
      if (newHeader) {
        const h = newHeader.offsetHeight;
        // Use the largest header height (safe)
        headerHeight = Math.max(headerHeight, h);
      }
    }

    // ----- CHECK IF ELEMENT IS OUT OF VIEW -----
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const fullyVisible =
      rect.top >= headerHeight &&
      rect.bottom <= viewportHeight;

    if (fullyVisible) return; // No scroll needed

    // ----- SCROLL TO TOP WITH HEADER OFFSET -----
    const absoluteY =
      window.scrollY + rect.top - headerHeight - 20;

    window.scrollTo({
      top: absoluteY,
      behavior: "smooth"
    });
  });
})();